import React from "react";

function TransactionItem({ label, amount, icon }) {
    // const baseURL = "http://localhost:3000/"; 

  return (
    <div className="flex gap-10 justify-between items-center mt-2.5 w-full text-black">
      <div className="self-stretch my-auto text-xs">{label}</div>
      <div className="flex gap-1 items-center self-stretch my-auto text-base font-bold">
        {icon && (
          <img
            loading="lazy"
            src={icon}
            className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
            alt=""
          />
        )}
        <div className="self-stretch my-auto">{amount}</div>
        
      </div>
    </div>
    
  );
}

export default TransactionItem;